// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indented-panel{height:100%;width:90%;margin-left:5%}@media only screen and (max-width:992px){.indented-panel{margin:0 20px;width:auto}}", ""]);
// Exports
module.exports = exports;
